import { defineMessages, useIntl } from 'react-intl';

import EmptyState from '@atlaskit/empty-state';
import Image from '@atlaskit/image';
import { Box, xcss } from '@atlaskit/primitives';
import Text from '@atlaskit/primitives/text';

import EmptySearchResultImage from './assets/empty.svg';

const messages = defineMessages({
  header: {
    id: 'side-nav.starred-empty-state.header',
    defaultMessage: "You haven't starred anything yet.",
    description:
      'Header text shown when the user has no starred items in the navigation flyout.',
  },
  description: {
    id: 'side-nav.starred-empty-state.description',
    defaultMessage:
      "In the sidebar, open the repo or project's context menu and select Star to pin it to your Starred list for fast access from anywhere in Bitbucket.",
    description:
      'Description text shown when the user has no starred items, explaining how to star items.',
  },
  imageAlt: {
    id: 'side-nav.starred-empty-state.image-alt',
    defaultMessage: 'No starred items',
    description:
      'Alt text for the empty state image when there are no starred items.',
  },
});

const textWrapperStyles = xcss({
  maxWidth: '235px',
  marginInline: 'auto',
  display: 'inline-block',
});

export const StarredEmptyState = () => {
  const { formatMessage } = useIntl();

  const EmptyStateImage = () => (
    <Image
      src={EmptySearchResultImage}
      width={96}
      alt={formatMessage(messages.imageAlt)}
    />
  );

  return (
    <EmptyState
      header={formatMessage(messages.header)}
      description={
        <Box as="span" xcss={textWrapperStyles}>
          <Text size="small">{formatMessage(messages.description)}</Text>
        </Box>
      }
      headingLevel={3}
      headingSize="xsmall"
      renderImage={EmptyStateImage}
    />
  );
};
